export default __webpack_public_path__ + "static/media/indoor.16af9d2b.svg";